<div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
  
                <div class="col-md-10 report-main-content m-t-5">
                  <div class="coupon-card">
                    <div class="game-heading">
                      <span class="card-header-title">Our Casino </span>
                    </div>
                  </div>
                  <div>
                    <div class="m-b-30 div-figure" 
                    *ngFor="let game of gameList" routerLink="/casino-detail/{{game.code}}/{{game.providerCode}}">
                      <a>
                        <img src="{{game.thumb}}" class="img-fluid">
                      </a>
                    </div>
                   
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>